const USER_ACTION_TYPE = {
  GET_USERS: 'GET_USERS',
  GET_USER: 'GET_USER',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER'
}
export default USER_ACTION_TYPE
